export enum ColumnType {
  FILTER, STRING, DATE, TIMESTAMP, BOOLEAN, LONG, INTEGER, DOUBLE, FLOAT, ENUM, LOOKUP, ARRAY_INTEGER
}
